import React from 'react';
import './index.css';
import List from './list.js';
import Add from './add.js';
import { Route } from 'react-router-dom';

class Content extends React.Component {
  constructor(){
    super();
    this.state = {
      typeList : false
    }
  }
  render(){
    const { parent, menu } = this.props;
    // console.log(parent);
    // console.log(menu);
    let done = true;
    return (
      <div id="manageMain" className="content-main">
        {  (parent === menu) && done ?
          <Route path={ window.path } component={ List } /> :<Route path={ window.path } component={ Add } />
        }
      </div>
    )
  }
}
export default Content;



// WEBPACK FOOTER //
// ./src/component/builder/content.js